<script lang="ts" setup>
  import { useBasicSEO } from '~/composables/basicSeo';

  useBasicSEO();
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-[100vh] bg-[#141D27] overflow-hidden">
    <slot />
  </div>
</template>
